import couponService from "src/services/couponService";

// private coupon
export const GET_LIST_PRIVATE_COUPON_REQUEST =
  "@promotion/get-list-private-coupon-request";
export const GET_LIST_PRIVATE_COUPON_SUCCESS =
  "@promotion/get-list-private-coupon-success";
export const GET_LIST_PRIVATE_COUPON_FAILURE =
  "@promotion/get-list-private-coupon-failure";

export const ADD_PRIVATE_COUPON_REQUEST = "@promotion/add-private-coupon-request";
export const ADD_PRIVATE_COUPON_SUCCESS = "@promotion/add-private-coupon-success";
export const ADD_PRIVATE_COUPON_FAILURE = "@promotion/add-private-coupon-failure";

// private coupon
export const GET_LIST_COUPON_BUDGET_REQUEST = "@promotion/get-list-coupon-budget-request";
export const GET_LIST_COUPON_BUDGET_SUCCESS = "@promotion/get-list-coupon-budget-success";
export const GET_LIST_COUPON_BUDGET_FAILURE = "@promotion/get-list-coupon-budget-failure";

export const GET_COUPON_LIMIT_REQUEST = "@promotion/get-coupon-limit-request";
export const GET_COUPON_LIMIT_SUCCESS = "@promotion/get-coupon-limit-success";
export const GET_COUPON_LIMIT_FAILURE = "@promotion/get-coupon-limit-failure";

// private coupon
export function getListPrivateCoupon(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_PRIVATE_COUPON_REQUEST});
      const response = await couponService.getListPrivateCoupon(params);
      dispatch({
        type: GET_LIST_PRIVATE_COUPON_SUCCESS,
        payload: {
          response: response.data,
          total: response.total_items || 0
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_PRIVATE_COUPON_FAILURE});
      throw error;
    }
  };
}

export function createPrivateCoupon(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: ADD_PRIVATE_COUPON_REQUEST});
      const response = await couponService.createPrivateCoupon(data);
      dispatch({
        type: ADD_PRIVATE_COUPON_SUCCESS,
        payload: {
          response: response.data
        }
      });
    } catch (error) {
      dispatch({type: ADD_PRIVATE_COUPON_FAILURE});
      throw error;
    }
  };
}

// private coupon
export function getListCouponBudget(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_COUPON_BUDGET_REQUEST});
      const response = await couponService.getListCouponBudget(params);
      dispatch({
        type: GET_LIST_COUPON_BUDGET_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_COUPON_BUDGET_FAILURE});
      throw error;
    }
  };
}

export function getCouponLimit() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_COUPON_LIMIT_REQUEST});
      const response = await couponService.getCouponLimit();
      dispatch({
        type: GET_COUPON_LIMIT_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_COUPON_LIMIT_FAILURE});
      throw error;
    }
  };
}

export function getCouponLimitSetting() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_COUPON_LIMIT_REQUEST});
      const response = await couponService.getCouponLimitSetting();
      dispatch({
        type: GET_COUPON_LIMIT_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_COUPON_LIMIT_FAILURE});
      throw error;
    }
  };
}
